module.exports = __webpack_public_path__ + "static/media/banner-pcp.b0d554c9.jpg";